<template>
<div>
<template v-if="attribute.type=='string'">
  <ClickEditInputText  :title="getTheTranslation(attribute,'translation')" :value="attribute.supplierattributes[0].attibutetextval" :valkey="attribute.id" :read_only="!attribute.supplier_can_edit" @dataChanged="attributeChanged"></ClickEditInputText>    
</template>

<template v-if="attribute.type=='number'">
<ClickEditNumber   :title="getTheTranslation(attribute,'translation')" :value="attribute.supplierattributes[0].attibutenumericalval" :valkey="attribute.id" :read_only="!attribute.supplier_can_edit" @dataChanged="attributeChanged" />
</template>

<template v-if="attribute.type=='boolean'">
<ClickEditSwitch    :title="getTheTranslation(attribute,'translation')" :value="attribute.supplierattributes[0].attibutenumericalval" :valkey="attribute.id" :read_only="!attribute.supplier_can_edit" @dataChanged="attributeChanged" />
</template>

<template v-if="attribute.type=='categorised'">
<ClickEditCategory   :allcategories="attribute.categories" :title="getTheTranslation(attribute,'translation')" :value="attribute.supplierattributes[0].attibutenumericalval" :valkey="attribute.id" @dataChanged="attributeChanged" />
</template>

<template v-if="attribute.type=='cascadecategorised'">
<ClickEditCascadeCategory   :allcategories="attribute.categories" :title="getTheTranslation(attribute,'translation')" :value="attribute.supplierattributes[0].attibutenumericalval" :valkey="attribute.id" @dataChanged="attributeChanged" />
</template>

<template v-if="attribute.type=='select'">
<ClickEditSelect    :title="getTheTranslation(attribute,'translation')" :value="attribute.supplierattributes[0].attibutenumericalval" :valkey="attribute.id" @dataChanged="attributeChanged" valkey="languages" :options="attribute.options"  :read_only="!attribute.supplier_can_edit" :color_selector="true"/>    
</template>

<template v-if="attribute.type=='multiselect'">
<ClickEditMultiSelect    :title="getTheTranslation(attribute,'translation')" :value="optionsformultiselect" :valkey="attribute.id" @dataChanged="attributeChanged" valkey="languages" :options="attribute.options"  :read_only="attribute.supplier_can_edit" :color_selector="true"/>    
</template>


</div>	
</template>

<script>
export default {

  name: 'CustomAttributeEditor',
  props:["attribute","item_id"],
  data () {
    return {
    	mainattribute:null,
    }
  },
  computed:{
    optionsformultiselect()
    {
      if(this.attribute && this.attribute.supplierattributes.length && this.attribute.supplierattributes[0].attibutetextval)
      {
        let values =  JSON.parse(this.attribute.supplierattributes[0].attibutetextval)

        let arr = []
        for(let value of values)
        {
          let ind = this.attribute.options.findIndex((item=>item.id == value))
          if(ind !==-1)
          {
            arr.push(this.attribute.options[ind])
          }
        }
        return arr
      }
      return []
      
    },
  	theattribute()
  	{
  		return this.attribute
  	},
  },
  watch:{
  	theattribute()
  	{
  		this.mainattribute = this.theattribute
  	}
  },
  methods:{
  	attributeChanged(data)
    {
      console.log(data)
      //return false
      let formdata = new FormData()
      if(this.attribute.type=="multiselect")
      {
        formdata.append("data",JSON.stringify(data.value))
      }
      else
      {
        formdata.append("data",data.value)
      }
      formdata.append("customattribute_id",data.key)
      this.generalSubmission(formdata,"supplier/update_custom_attribute_val/"+this.item_id,this.afterdataChanged)
    },
    afterdataChanged(response)
    {
    	this.$emit("dataReneved")
    }
  }
}
</script>

<style lang="css" scoped>
</style>